export class AdminRuntimeQueueStats {
  queueKey: string

  queueName: string

  description: string

  waitingCount: number

  processingCount: number

  totalEnqueued: number

  totalDequeued: number

  totalSucceeded: number

  totalFailed: number

  healthStatus: string

  healthMessage: string | null

  constructor(data: Partial<AdminRuntimeQueueStats> = {}) {
    this.queueKey = data.queueKey ?? ""

    this.queueName = data.queueName ?? ""

    this.description = data.description ?? ""

    this.waitingCount = data.waitingCount ?? 0

    this.processingCount = data.processingCount ?? 0

    this.totalEnqueued = data.totalEnqueued ?? 0

    this.totalDequeued = data.totalDequeued ?? 0

    this.totalSucceeded = data.totalSucceeded ?? 0

    this.totalFailed = data.totalFailed ?? 0

    this.healthStatus = data.healthStatus ?? "Saudável"

    this.healthMessage = data.healthMessage ?? null
  }
}
